export const WORDS: string[] = [
  'agile',
  'albatross',
  'apricot',
  'ardent',
  'aspen',
  'aurora',
  'badger',
  'blizzard',
  'bramble',
  'breezy',
  'brilliant',
  'brisk',
  'bronze',
  'calm',
  'cascade',
  'charming',
  'clover',
  'cotton',
  'crisp',
  'cypress',
  'dainty',
  'dandelion',
  'dapper',
  'dormant',
  'drizzle',
  'dusk',
  'eager',
  'echo',
  'egret',
  'elegant',
  'elm',
  'ember',
  'fable',
  'faint',
  'fen',
  'fiery',
  'fjord',
  'flint',
  'gadget',
  'gale',
  'garnet',
  'grove',
  'harvest',
  'hazel',
  'hazy',
  'hearty',
  'horizon',
  'icicle',
  'icy',
  'indigo',
  'inlet',
  'iris',
  'jade',
  'jaded',
  'jovial',
  'jubilant',
  'jungle',
  'juniper',
  'keen',
  'kernel',
  'kettle',
  'koi',
  'lantern',
  'lattice',
  'lemur',
  'lively',
  'loam',
  'lucid',
  'majestic',
  'maple',
  'meadow',
  'mellow',
  'mocha',
  'mosaic',
  'neat',
  'nebula',
  'nectarine',
  'nimble',
  'noodle',
  'nova',
  'oasis',
  'ominous',
  'onyx',
  'opal',
  'opaque',
  'orb',
  'paragon',
  'pebble',
  'plaza',
  'plucky',
  'prism',
  'pristine',
  'quaint',
  'quartz',
  'quirky',
  'raccoon',
  'radiant',
  'ripple',
  'robust',
  'rosette',
  'rustic',
  'sable',
  'sage',
  'shady',
  'sleek',
  'spruce',
  'sycamore',
  'tangerine',
  'tidy',
  'timid',
  'topaz',
  'trellis',
  'truffle',
  'ultra',
  'umbra',
  'unique',
  'upbeat',
  'uplift',
  'usher',
  'vast',
  'velvet',
  'verve',
  'vine',
  'vivid',
  'warp',
  'whisper',
  'willow',
  'wise',
  'witty',
  'wren',
  'xenon',
  'yarrow',
  'yonder',
  'youthful',
  'zealous',
  'zenith',
  'zest',
  'the',
  'and',
  'or',
  'but',
  'if',
  'then',
  'else',
  'when',
  'where',
  'why',
  'how',
  'what',
  'this',
  'that',
  'these',
  'those',
  'whose',
  'which',
  'because',
  'while',
  'unless',
  'until',
  'over',
  'under',
  'before',
  'after',
  'since',
  'though',
  'although',
  'besides',
  'amid',
  'within',
  'without',
  'upon',
  'across',
  'beyond',
  'among',
  'between',
  'against',
  'during',
  'despite',
  'toward',
  'except',
  'hence',
  'thus',
  'also',
  'however',
  'my',
  'your',
  'his',
  'her',
  'its',
  'their',
  'who',
  'whom',
  'whichever',
];
